import * as React from 'react';

const CheckmarkShieldFilled64 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 64 65", width: 64, height: 64, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M30.008 57.25c1.27.58 2.711.58 3.981 0 5.357-2.447 19.676-10.37 19.676-25.165V16.696a4 4 0 0 0-2.645-3.763L34.031 6.817a6 6 0 0 0-4.065 0l-16.989 6.116a4 4 0 0 0-2.645 3.763v15.389c0 14.796 14.32 22.718 19.676 25.164Zm13.794-33.12-12.56 12.926a1.6 1.6 0 0 1-2.294 0l-7.297-7.506a1.5 1.5 0 1 1 2.151-2.091l6.293 6.474L41.651 22.04a1.5 1.5 0 1 1 2.151 2.09"
  }
));
CheckmarkShieldFilled64.Size = 64;
CheckmarkShieldFilled64.Title = "CheckmarkShieldFilled";

export { CheckmarkShieldFilled64 as default };
